import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';


const SubscriptionTable = ({ accountDetail, handleSubscriptionDetail }) => {
  return (
    <div className="accounts-roles-table">
      <div className="table-wrapper">
        <div className="table-head">
          <table>
            <thead>
              <tr className="table-row table-row-head">
                <th className="table-cell table-cell-name">
                  <span className="text-left display-block padding-left-15">SUBSCRIPTION</span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">NO. OF SEATS</span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">ACCESS START DATE</span>
                </th>
                <th className="table-cell table-cell-date">
                  <span className="text-left display-block padding-left-15">ACCESS END DATE</span>
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="table-body">
          <table>
            <tbody>
              {
                accountDetail.entitlements.map((entitlement, i) => {
                  const { name = '', seats = 0, accessStart, accessEnd } = entitlement;
                  if (entitlement.contractId.trim() && (!entitlement.hidden)) {
                    return (
                      <tr key={`${accountDetail.accountId}_${i}`} className="table-row table-row-body">
                        <td className="table-cell table-cell-name" >
                          <button onClick={() => handleSubscriptionDetail(entitlement)} className="table-cell-button">
                            <span className="col-text">{name}</span>
                          </button>
                        </td>
                        <td className="table-cell table-cell-date" >
                          <span className="col-text text-left">{seats}</span>
                        </td>
                        <td className="table-cell table-cell-date" >
                          <span className="col-text text-left">{moment(accessStart).format('MM DD YYYY hh:mm:ss')}</span>
                        </td>
                        <td className="table-cell table-cell-date" >
                          <span className="col-text text-left">{moment(accessEnd).format('MM DD YYYY hh:mm:ss')}</span>
                        </td>
                      </tr>
                    );
                  }
                  return null;
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};


SubscriptionTable.propTypes = {
  accountDetail: PropTypes.instanceOf(Object),
  handleSubscriptionDetail: PropTypes.func,
};

export default SubscriptionTable;
